import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../features/auth/AuthContext';

export const MarketingHeader = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    
    // If we're not on the homepage, navigate first
    if (location.pathname !== '/') {
      window.location.href = `/${hash}`;
      return;
    }
    
    // Smooth scroll to the element
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="marketing-header">
      <div className="marketing-container">
        <div className="marketing-header-content">
          <Link to="/" className="marketing-logo">
            <div className="marketing-logo-container">
              <img src="/images/Simcarlo Logo.png" alt="Simcarlo Logo" className="marketing-logo-img" />
              <div className="marketing-logo-badge">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 0L7.5 4.5L12 6L7.5 7.5L6 12L4.5 7.5L0 6L4.5 4.5L6 0Z" fill="currentColor"/>
                </svg>
              </div>
            </div>
            <span className="marketing-logo-text">
              <span className="marketing-logo-text-main">Sim</span>
              <span className="marketing-logo-text-accent">carlo</span>
            </span>
          </Link>
          <nav className="marketing-nav marketing-nav-desktop">
            <a 
              href="#features" 
              className="marketing-nav-link"
              onClick={(e) => handleAnchorClick(e, '#features')}
            >
              Features
            </a>
            <a 
              href="#how-it-works" 
              className="marketing-nav-link"
              onClick={(e) => handleAnchorClick(e, '#how-it-works')}
            >
              How It Works
            </a>
            <Link to="/pricing" className="marketing-nav-link">Pricing</Link>
            <Link to="/faq" className="marketing-nav-link">FAQ</Link>
            {user ? (
              <Link to="/workspace" className="marketing-btn marketing-btn-primary">
                Open Workspace
              </Link>
            ) : (
              <>
                <Link to="/login" className="marketing-nav-link">Login</Link>
                <Link to="/signup" className="marketing-btn marketing-btn-primary">
                  Sign Up
                </Link>
              </>
            )}
          </nav>
          <button 
            className="marketing-mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className={`marketing-hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
      {/* Mobile Menu Overlay */}
      <div 
        className={`marketing-mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
        aria-hidden="true"
      ></div>
      {/* Mobile Menu Drawer */}
      <nav className={`marketing-mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="marketing-mobile-menu-content">
          <a 
            href="#features" 
            className="marketing-mobile-nav-link" 
            onClick={(e) => handleAnchorClick(e, '#features')}
          >
            Features
          </a>
          <a 
            href="#how-it-works" 
            className="marketing-mobile-nav-link" 
            onClick={(e) => handleAnchorClick(e, '#how-it-works')}
          >
            How It Works
          </a>
          <Link to="/pricing" className="marketing-mobile-nav-link" onClick={toggleMobileMenu}>
            Pricing
          </Link>
          <Link to="/faq" className="marketing-mobile-nav-link" onClick={toggleMobileMenu}>
            FAQ
          </Link>
          {user ? (
            <Link 
              to="/workspace" 
              className="marketing-btn marketing-btn-primary marketing-mobile-cta"
              onClick={toggleMobileMenu}
            >
              Open Workspace
            </Link>
          ) : (
            <>
              <Link 
                to="/login" 
                className="marketing-mobile-nav-link"
                onClick={toggleMobileMenu}
              >
                Login
              </Link>
              <Link 
                to="/signup" 
                className="marketing-btn marketing-btn-primary marketing-mobile-cta"
                onClick={toggleMobileMenu}
              >
                Sign Up
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

